// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";
import { getAuth } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyCpzDgUs4CO_UdSU1lRqsAR2swZRP3nBCY",
//   authDomain: "citamed247.firebaseapp.com",
//   projectId: "citamed247",
//   storageBucket: "citamed247.appspot.com",
//   messagingSenderId: "952372042158",
//   appId: "1:952372042158:web:67877ccfeaf75d2ef2903f",
//   measurementId: "G-5K8ZN9WC6F",
// };

const firebaseConfig = {
  apiKey: "AIzaSyCG-xkqicRhhysUArRM4XqZP6IOm1wLUfo",
  authDomain: "app24siete.firebaseapp.com",
  databaseURL: "https://app24siete-default-rtdb.firebaseio.com",
  projectId: "app24siete",
  storageBucket: "app24siete.firebasestorage.app",
  messagingSenderId: "195813114510",
  appId: "1:195813114510:web:5ec448f90555265b5b3fdf",
  measurementId: "G-RKB1J9LY19"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const database = getDatabase(app);
const messaging = getMessaging(app);
const auth = getAuth(app);

export { database, analytics, messaging, auth };
